import { Hero,Portrait,IconRow,IconRow2 } from "./hero.styles"
import ContactMe from "../ContactPage/ContactInfo.component"
// import { Notice } from "./hero.styles"
// import { Notice } from '../Form/Notice'
// import Notice from "./Form/Notice"
import photo from '../../assets/book_shelf_portrait_2.png'
import { largeGitBash,contactIcon,resumeIcon,ait_ico,instagram,facebook,linkedin } from "../Styles/large-svg"
// import {  } from "../Styles/large-svg"
// import AIT_icon from '../assets/AIT_icon.ico'
// import { ReactComponent as Logo } from "../assets/AIT_icon.svg";
import { palette } from "../Styles/colors"
import { useState,useEffect } from "react"
import routes from "../../routes"
import { Link } from "react-router-dom"
import { useContext } from "react"
import { AppContext } from "../Context/app.context"

const { deepBlue } = palette

const HeroView = () => {

    // const [contact,setContact] = useState(false)
    // const [notice,setNotice] = useState(null)
    const { contact,setContact } = useContext(AppContext)

    const handler = (param) => {
        console.log('hit handler in hero',param)
    }

    // const location = window.location.pathname.split('/')[1]
    const addressParam = window.location.pathname.split('/')[1]

    useEffect(() => {
        try {
            if (addressParam === 'contact') {
                setContact(true)
            }
        } catch (err) {
            console.log('there was an error',err)
        }
    },[])

    // console.log('this is the router', location.length)

    // useEffect(() => {
    //     try {
    //         if (location === 'contact') {
    //             setContact(true)
    //         }
    //     } catch (err) {
    //         console.log('there was an error',err)
    //     }
    // },[])

    // const addressParam = window.location.pathname.split('/')[1]

    // useEffect(() => {
    //     try {
    //         if (addressParam === 'contact') {
    //             setContact(true)
    //         }
    //     } catch (err) {
    //         console.log('there was an error',err)
    //     }
    // },[])

    // console.log('this is the router', location.length)

    // const changeNotice = (val) => {
    //     setNotice(val)
    // }

    return (
        <Hero>
            <h1>Developer, Maker, Citizen Scientist</h1>
            <p>I design and code beautifully simple things, and I love what I do.</p>
            {/* <Portrait><img src={'https://firebasestorage.googleapis.com/v0/b/depot-7bb3e.appspot.com/o/Chris%20deMontigny%2Fphotos%2FFB_IMG_1508768299982.JPEG?alt=media&token=1920934c-af9d-4e5b-986f-51ce89dd8a57'}/></Portrait> */}
            <Portrait><img src={photo}/></Portrait>
            {/* {contact &&
            <ContactMe
                setContact={setContact}
                changeNotice={changeNotice}
            />} */}
            {/* {routes} */}

            {/* {notice &&
            <Notice
                notice={notice}
                changeNotice={changeNotice}
            />} */}


                <IconRow>

                <a
                    href="https://github.com/Nefari0"
                    target="_blank"
                >
                {largeGitBash()}
                </a>

                <a
                    // to={'/'}
                    style={{color:`${deepBlue}`}}
                    onClick={() => setContact(!contact)}
                >
                {contactIcon()}
                </a>

                <a
                    style={{color:`${deepBlue}`}}
                    href="https://docs.google.com/document/d/1vuy1o8nDqVc-_QHipp9tQ93P4V3L6B3H01vW2l-_FHA/edit"
                    target="_blank"
                >
                {resumeIcon()}
                </a>
                
                {/* <img src={AIT_icon}/> */}
                </IconRow>

                <IconRow2>
                    <a
                        href="http://adrift.madmodels3d.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {ait_ico()}
                    </a>
                    <a
                        href="https://www.instagram.com/chris_demontigny/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {instagram()}
                    </a>
                    <a
                        href="https://www.facebook.com/chris.demontigny/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {facebook()}
                    </a>
                    <a
                        href="https://www.linkedin.com/in/chris-demontigny-793983203"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {linkedin()}
                    </a>
                </IconRow2>

        </Hero>
    )
} 

export default HeroView

{/* <img alt="LinkedIn png social media icon. 7 JUNE 2021 - BANGKOK, THAILAND" crossorigin="anonymous" loading="lazy" decoding="async" property="contentUrl" itemprop="contentUrl" class="sc-8a9ca9ef-0 lhsgez teaser-image lazy-image-loaded" content="https://images.rawpixel.com/image_png_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvdjk4Mi1kMy0xMC5wbmc.png" fetchpriority="auto" width="450" height="450" srcset="https://images.rawpixel.com/image_png_450/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvdjk4Mi1kMy0xMC5wbmc.png" src="https://images.rawpixel.com/image_png_800/czNmcy1wcml2YXRlL3Jhd3BpeGVsX2ltYWdlcy93ZWJzaXRlX2NvbnRlbnQvbHIvdjk4Mi1kMy0xMC5wbmc.png"> */}